module.exports = __webpack_public_path__ + "img/map_pc_2.6fc92a48.png";